module.exports = function (_this) {
  return "\n    <div id=\"cardstack_".concat(_this.name, "\" class=\"cardstack ").concat(_this.orientation, "\">\n      <div id=\"cardstack_").concat(_this.name, "_empty\" class=\"card-slot cs-empty\"></div>\n    </div>\n    ");
};